export default __webpack_public_path__ + "static/media/avatar.c991d831.svg";